export const mediumBreakpoint = 500;
export const largeBreakpoint = 768;
export const extraLargeBreakpoint = 1024;

export const medium = `(min-width: ${mediumBreakpoint}px)`;
export const large = `(min-width: ${largeBreakpoint}px)`;
export const extraLarge = `(min-width: ${extraLargeBreakpoint}px)`;
